module.exports = __webpack_public_path__ + "static/social-card-c8b18458b603294b5002c98abc918d62.jpg";